import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getMasterOptions, setAccountDataInOption, getGeneralSetting, getAccountMasterOptions, getTablesVersions } from '@/redux/actions';
import { selectAuth, selectAccountOptions, selectBookOptions, selectShouldFetchMasterApi, selectShouldFetchSettingsApi, selectTableVersions } from '@/redux/selector';
import { MODULE_IDS } from '@/components/PermissionsContext';
import { TABLES } from '@/utils';
import * as _ from 'lodash';

export const CommonCall = () => {
    const dispatch = useDispatch();
    const auth = useSelector(selectAuth, shallowEqual);
    const accounts = useSelector(selectAccountOptions, shallowEqual);
    const books = useSelector(selectBookOptions, shallowEqual);
    const isLoaded = useSelector(selectShouldFetchMasterApi, shallowEqual);
    const isSettingLoaded = useSelector(selectShouldFetchSettingsApi, shallowEqual);
    const tableVersions = useSelector(selectTableVersions, shallowEqual);
    const versionRef = useRef(tableVersions || {});

    useEffect(() => {
        if (!auth?.company?.id || !auth?.customer?.id) {
            return;
        }

        dispatch(getTablesVersions([TABLES.Accounts, TABLES.Items, TABLES.Books, TABLES.GeneralSettings])).then((versions) => {
            const shouldFetchAcc = versionRef.current[TABLES.Accounts] !== versions[TABLES.Accounts];
            const shouldFetchBook = versionRef.current[TABLES.Books] !== versions[TABLES.Books];
            const shouldFetchItem = versionRef.current[TABLES.Items] !== versions[TABLES.Items];
            const shouldFetchSetting = versionRef.current[TABLES.GeneralSettings] !== versions[TABLES.GeneralSettings];
            if (shouldFetchAcc) {
                dispatch(getAccountMasterOptions(true, true));
            }
            if (shouldFetchItem) {
                dispatch(getMasterOptions(MODULE_IDS.ITEM, true));
            }
            if (shouldFetchBook) {
                dispatch(getMasterOptions(MODULE_IDS.BOOK, true, true));
            }
            if (shouldFetchSetting) {
                dispatch(getGeneralSetting(true));
            }
            versionRef.current = versions;
        }).catch((error) => {
            console.log('<<Error--', error);
            if (!isLoaded) {
                dispatch(getMasterOptions(MODULE_IDS.BOOK, true, true));
                dispatch(getAccountMasterOptions(true, true));
                dispatch(getMasterOptions(MODULE_IDS.ITEM, true));
            }
            if (!isSettingLoaded) {
                dispatch(getGeneralSetting(true));
            }
        })
    }, [auth?.company?.id, auth?.customer?.id, isLoaded, isSettingLoaded]);

    useEffect(() => {
        if (accounts) {
            let data = [];
            const active = [];
            const map = new Map();

            const bookAccounts = books.map((book) => parseInt(book.Account_Id));
            accounts
            .filter((data) => (!bookAccounts.includes(data.id) && !data.isSystem))
            .forEach((account) => {
                // if (!account.DeActive) {
                    if (account.Addresses?.length) {
                        account.Addresses.forEach((address) => {
                            const add = [address.Address1, address.Address2, address.Address3, address?.State?.State_Name].filter((data) => data);
                            const newAccount = {
                                ...account,
                                Address_Id: address.id || null,
                                Broker: account?.Broker?.Brocker_Name,
                                BrokerData: account?.Broker,
                                SalesPersonData: account?.SalesPerson,
                                Schedule: account?.Schedule?.Schedule_Name,
                                Transporter: account?.Transporter?.Transporter_Name,
                                Address: `${add.join(', ')}`,
                                City: address.City,
                                DeActive: account.DeActive ? 'Yes' :  'No',
                                isActive: !account.DeActive,
                                accountId: account.id,
                                gstLedger: `${account.GSTIN_No || ''} \n\n(${account.ledgerAmount || '0.00'})`,
                                id: `${account.id}-${address.id || ''}`
                            }
                            account.DeActive ? map.set(newAccount.id, newAccount) : active.push(newAccount);
                            data.push(newAccount);
                        })
                    } else {
                        const newAccount = {
                            ...account,
                            Address_Id: null,
                            Broker: account?.Broker?.Brocker_Name,
                            SalesPersonData: account?.SalesPerson,
                            Schedule: account?.Schedule?.Schedule_Name,
                            Transporter: account?.Transporter?.Transporter_Name,
                            DeActive: account.DeActive ? 'Yes' :  'No',
                            isActive: !account.DeActive,
                            accountId: account.id,
                            gstLedger: `${account.GSTIN_No || ''} \n\n(${account.ledgerAmount || '0.00'})`,
                            id: `${account.id}-`
                        }
                        account.DeActive ? map.set(newAccount.id, newAccount) : active.push(newAccount);
                        data.push(newAccount);
                    }
                // }
            });
            dispatch(setAccountDataInOption({
                accountsData: _.orderBy(data, ['Party_Name'], ['asc']),
                activeAccountsData: _.orderBy(active, ['Party_Name'], ['asc']),
                accountsMap: map
            }));  
        }
    }, [accounts, books]);

    return null;
}
